import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
} from '@angular/core';
import { ProgressUpdate } from '@model';
import { LoaderService, ResultService } from '@service';

@Component({
  selector: 'optima-progress',
  templateUrl: './progress.component.html',
  styleUrls: ['./progress.component.scss'],
})
export class ProgressComponent implements OnChanges {
  @Input() progress: ProgressUpdate = { progress: 0, timestamp: '', tick: 0 };
  @Input() cadence = 1;
  @Input() translateString = null;
  @Input() translateStringSubtext = null;
  @Output() restartCallback: EventEmitter<boolean> = new EventEmitter();
  stage: 'initializing' | 'iterating' | 'finalizing' | 'stalled' =
    'initializing';
  estimation = 0;
  subset: number[] = [];
  private readonly STALLED_THRESHOLD_MINS = 5;

  constructor(
    public loaderService: LoaderService,
    public resultService: ResultService,
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['progress']) {
      if (this.progress.progress != this.subset[this.subset.length - 1]) {
        this.subset.push(this.progress.progress);
        this.estimate();
        if (this.subset.length > 3) {
          this.subset.shift();
        }
      }
      this.setStage(this.progress);
    }
  }

  setStage(progress: ProgressUpdate): void {
    if (progress.progress == 0) {
      this.stage = 'initializing';
      this.subset = [];
    } else if (progress.progress == 100) {
      this.stage = 'finalizing';
    } else {
      this.stage = 'iterating';
      const now = new Date();
      const stalledMs = now.getTime() - this.STALLED_THRESHOLD_MINS * 60 * 1000;
      if (new Date(this.progress.timestamp).getTime() <= stalledMs) {
        this.stage = 'stalled';
      }
    }
  }

  estimate(): void {
    if (this.subset.length >= 3) {
      const average =
        (this.subset[this.subset.length - 1] - this.subset[0]) /
        (this.subset.length - 1);
      const left = 100 - this.progress.progress;
      const steps_left = left / average;
      this.estimation = steps_left * this.cadence * 60;
    }
  }
  restartSimulation(): void {
    console.log('restarted');
    this.restartCallback.emit(true);
  }

  protected readonly Math = Math;
}
